import { getBaseurl } from "@/utils/url-parse";
import { API } from "@akc/biz-api";
import { Request } from "./request";
const baseUrl = getBaseurl();
export interface UserVisitInfo {
  /** 1:游客，已获取到openID,2:游客，已授权微信头像和昵称，待绑定手机号，3:游客，手机号改绑确认中（已提交手机号但该号已被人占用），0：正式用户（已绑手机号） */
  visitorStatus?: 0 | 1 | 2 | 3;
  /** true：已经授权（是否已获取到openID，后端定义是visitorStatu!=1），false：未授权 */
  isAuthorized?: boolean;
  /** true：已经绑定手机号，false：未绑定手机号（根据后端定义，游客一定尚未绑手机号，正式用户在某些场景也可能没绑） */
  isBindPhone?: boolean;
  /** true：是游客 (后端定义是visitorStatu!=0,部分主链路中需要绑定手机号)，false：不是游客 (部分主链路中无需绑定手机号) */
  isVisitor?: boolean;
  /** 2：安吉这一类第三方内嵌饷店的场景 */
  thirdLoginScene?: 2;
}

// 查询用户授权绑定状态
const queryBindCheck = async () =>
  API.get<UserVisitInfo>({
    hostID: "h5shop",
    path: "/api/member/auth/common/bindCheck",
  });

/**
 * @link https://yapi.akcops.com/project/669/interface/api/141930
 * @description 获取当前登录用户的visitorStatus
 * @author 郎齐鹏
 */
export const visitorInfo = async () =>
  API.get<Omit<UserVisitInfo, "isBindPhone" | "isVisitor">>({
    hostID: "h5shop",
    path: "/api/member/auth/xdwxh5/visitorInfo",
  });

// 管理员-登陆退出
const adminLogout = function () {
  return Request({
    url: `${getBaseurl()}/api/member/logout`,
    method: "post",
  });
};

// 隐藏入口控制
// https://yapi.akcops.com/project/2507/interface/api/394359
const queryHideInfo = async (params?: any) => {
  const res = await Request({
    url: `${getBaseurl()}/api/member/multi/member/hideEntry`,
    method: "post",
    data: params,
  });
  return res?.data;
};

// 设置隐藏
// https://yapi.akcops.com/project/2507/interface/api/394341
const setHideInfo = async (params?: any) => {
  const res = await Request({
    url: `${getBaseurl()}/api/member/multi/member/setHideInfo`,
    method: "post",
    data: params,
  });
  return res?.data;
};

export const getShareShowNickNameSwitch = () =>
  API.get({
    path: `${baseUrl}/api/member/xdwxh5/member/distributorTag/shareViewName/status`,
  });

export { adminLogout, queryBindCheck, queryHideInfo, setHideInfo };
